import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import { useEffect, useRef, useState, useContext } from "react";
import authservices, { verifyAuth } from "../services/authservices";
import SubFooter from "./SubFooter";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

const Disclaimer = () => {
  const navigate = useNavigate();
  const [offset, setOffset] = useState(0);
  const advanceSectionRef = useRef(null);
  const [userAuth, setAuth, userAuthref] = useState(false);
  const { t } = useTranslation();

  const [siteDatacomes, setSiteData] = useState("");

  const [loginCheck, setloginCheck] = useState(false);

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);

  useEffect(() => {
    getSitedata();

    let userToken = localStorage.getItem("token");
    if (userToken) {
      setloginCheck(true);
    } else {
      setloginCheck(false);
    }
  }, [0]);

  const getSitedata = async () => {
    try {
      const data = await authservices.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (advanceSectionRef.current) {
        const sectionTop = advanceSectionRef.current.offsetTop;
        const sectionHeight = advanceSectionRef.current.offsetHeight;
        const pageOffset = window.pageYOffset;

        if (
          pageOffset >= sectionTop &&
          pageOffset <= sectionTop + sectionHeight
        ) {
          setOffset(pageOffset - sectionTop);
        } else {
          setOffset(0);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    checkuserAuth();
  }, [0]);

  const checkuserAuth = async () => {
    const token = localStorage.getItem("token");
    if (token != null) {
      try {
        const data = await verifyAuth(token);
        if (data && data.status) {
          setAuth(true);
        } else {
          setAuth(false);
        }
      } catch (error) {
        // console.error("Error auth user details:", error);
        setAuth(false);
      }
    } else {
      setAuth(false);
    }
  };

  const nav_page = () => {
    if (!userAuthref.current) {
      navigate("/register");
    } else {
      navigate("/home");
    }
  };

  return (
    <>
      <main className="wyscale_landing_main">
        <Header />

        <section className="dashboard_content_section">
          <div className="container">
            <div className="smart_dashboard_content" id="privacy-condition">
              {/* <h2>{t("Disclaimer")}</h2> */}
              <h2>{t("BinargeDisclaimer")}</h2>
              <p>{t("Updated_dates")}</p>

              <div className="row">
                <div className="col-lg-12">
                  <div className="dash_board_profile_content">
                    <div className="contentpage">
                      {t("Binarge_title_sub") && <h2>{t("Binarge_title_sub")}</h2>}
                      {/*
                        <p>
                        Binarge ("Binarge," "we," "our," or "us") values your privacy and is committed to transparency regarding how we handle data. This Privacy Policy applies to information we collect when you use our website and other online services that link to this Privacy Policy (collectively, the "Services").
                        </p>
                      */}

                      <h3>1. {t("NoFinancialAdvice")}</h3>
                      <p>{t("BinargeArbitrageBot1")}</p>
                      <p>{t("BinargeArbitrageBot2")}</p>
                    {t("BinargeArbitrageBot3") && <p>{t("BinargeArbitrageBot3")}</p>}

                      <h3>2. {t("UserControlsTheirFunds")}</h3>
                      <p>{t("UsersHaveFullControlOver1")}</p>
                      <p>{t("UsersHaveFullControlOver2")}</p>
                      <p>{t("UsersHaveFullControlOver_follows")}</p>

                      <ul>
                        <li>{t("withdraw_fundz")}</li>
                        <li>{t("transfer_assets")}</li>
                        <li>{t("ApK")}</li>
                        <li>{t("process_deposits")}</li>
                      </ul>

                      <p>{t("soley")}</p>

                      <h3>3. {t("NoMoney")}</h3>

                      <p>{t("HistoricalPerformance1")}</p>
                      <p>{t("HistoricalPerformance2")}</p>
                      <p>{t("HistoricalPerformance3")}</p>

                      <ul>
                        <li>{t("HP_list1")}</li>
                        <li>{t("HP_list2")}</li>
                        <li>{t("HP_list3")}</li>
                        <li>{t("HP_list4")}</li>
                      </ul>
                      <p>{t("technical_safety")}</p>

                      <h3>4. {t("Pre-Payment_Balance")}</h3>
                      <p>{t("pp_B_Follows")}</p>
                      <ul>
                        <li>{t("subscription_fee_payments")}</li>
                        <li>{t("profit-sharing_service_fees")}</li>
                      </ul>
                      <p>{t("Pb_cT")}</p>
                      <p>{t("MiCa")}</p>

                      <h3>5.{t("Affiliate_Rewards")}</h3>
                      <p>{t("separate_service_payouts")}</p>
                      <p>{t("rewards_follows")}</p>
                      {t("trading_capital") && <ul>
                        <li>{t("trading_capital")}</li>
                        <li>{t("asset_custody")}</li>
                        <li>{t("MiCA_withdrawal")}</li>
                      </ul>}
                      {t("MiCA_withdrawal2") && <p>{t("MiCA_withdrawal2")}</p>}

                      <h3>6. {t("No_Profit_Guarantee_title")}</h3>
                      <p>{t("No_Profit_Guarantee")}</p>
                      {t("No_Profit_Guarantee2") && <p>{t("No_Profit_Guarantee2")}</p>}
                      <p>{t("No_Profit_Guarantee_follows")}</p>
                      <ul>
                        <li>{t("market_fluctuations")}</li>
                        <li>{t("exchange_outages")}</li>
                        <li>{t("API_interruptions")}</li>
                        <li>{t("technical_failures")}</li>
                        {t("delays_or_slippage") && <li>{t("delays_or_slippage")}</li>}
                      </ul>
                      {t("eest") && <p>{t("eest")}</p>}

                      <h3>7. {t("APISecurity&_UserResponsibility")}</h3>
                      <p>{t("encryption")}</p>
                      <ul>
                        <li>{t("withdrawal_Disbaled")}</li>
                        <li>{t("IP_restrictions")}</li>
                        <li>{t("credentials_secure")}</li>
                      </ul>
                      <p>{t("API_configurations")}</p>


                      {/* <h3>8. {t("Legal&Regulatory_Position")}</h3>
                      <p>{t("software")}</p>
                      <p>{t("brokerages")}</p>
                      <p>{t("tax_obligations")}</p>
                      <p>{t("complying")}</p> */}
                      <h3>8. {t("Legal&Regulatory_Position")}</h3>

                      {t("software") && <p>{t("software")}</p>}
                      {t("brokerages") && <p>{t("brokerages")}</p>}
                      {t("tax_obligations") && <p>{t("tax_obligations")}</p>}

                      {t("MiCA1") && (
                        <ul>
                          {t("MiCA1") && <li>{t("MiCA1")}</li>}
                          {t("MiCA2") && <li>{t("MiCA2")}</li>}
                          {t("MiCA3") && <li>{t("MiCA3")}</li>}
                          {t("MiCA4") && <li>{t("MiCA4")}</li>}
                        </ul>
                      )}

                      {t("LR_final") && <p>{t("LR_final")}</p>}
                      {t("Last_final") && <p>{t("Last_final")}</p>}
                       {t("Carf_end") && <p>{t("Carf_end")}</p>}





                      {/* {
                        i18nextLngs == 'en' ?
                          (
                            <> */}

                      {/* </> */}
                      {/* // ) :
                          // (i18nextLngs == 'fi' || i18nextLngs == '') ? (
                          //   <> */}
                      {/* <h3>8. {t("Legal&Regulatory_Position")}</h3>
                              <p>{t("Regulatory_Position_instruct")}</p>
                              <p>{t("Follows_from_regulatory")}</p>
                              <ul>
                                <li>{t("reg_list1")}</li>
                                <li>{t("reg_list2")}</li>
                                <li>{t("reg_list3")}</li>
                                <li>{t("reg_list4")}</li>
                              </ul>
                              <p>{t("CARF_1")}</p>
                              <p>{t("CARF_2")}</p> */}
                      {/* //   </>
                          // ) : ("")
                      // } */}

                      <h3>9. {t("Intellectual_Property")}</h3>
                      <p>{t("BlockBond_Capital")}</p>
                         {t("BlockBond_Capital2") && <p>{t("BlockBond_Capital2")}</p>}
                      
                      <h3>{t("Disc_laimer")}</h3>
                      <p>{t("broker__dealer1")}</p>
                      <p>{t("cryptocurrency_portfolios")}</p>
                      <ul>
                      
                        <li>{t("broker__dealer")}</li>
                        <li>{t("accounting")}</li>
                        <li>{t("solicitation")}</li>
                        <li>{t("fund_prices")}</li>
                        <li>{t("Displayed_images")}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SubFooter />
      </main>
    </>
  );
};

export default Disclaimer;
